/**
 * Product video accessibility (WCAG 2.2.2 Pause, Stop, Hide)
 *
 * Added 2026-07-23 for the Jul 23 audit finding T2: the PDP product video is
 * an 80-second autoplaying loop with no pause mechanism. The theme's
 * SuperPoweredVideo component (global.js) re-issues play() every time the
 * video intersects the viewport, so a one-off pause is not enough: this
 * script wins by re-pausing inside the 'play' event whenever the user has
 * paused, or when the visitor prefers reduced motion and has not explicitly
 * started playback.
 *
 * Also honors prefers-reduced-motion for every superpowered-video on the
 * site (the theme's reduced-motion CSS blocks never targeted video).
 *
 * The toggle button is rendered server-side in product-media.liquid with
 * [hidden]; it is only revealed here, so no dead control exists without JS.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function enhance(sp) {
    var video = sp.querySelector('video');
    if (!video || video.dataset.a11yVideoBound) return;
    video.dataset.a11yVideoBound = 'true';

    var figure = sp.closest('figure');
    var btn = figure ? figure.querySelector('[data-video-toggle]') : null;
    var userPaused = false;
    var userStarted = false;

    function setState(state) {
      if (!btn) return;
      btn.dataset.state = state;
      btn.setAttribute('aria-label', state === 'playing' ? 'Pause video' : 'Play video');
    }

    video.addEventListener('play', function () {
      // Defeat the IntersectionObserver autoplay when the user said stop,
      // or when reduced motion is on and the user never opted in.
      if (userPaused || (reduced.matches && !userStarted)) {
        video.pause();
        return;
      }
      setState('playing');
    });

    video.addEventListener('pause', function () {
      setState('paused');
    });

    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          userStarted = true;
          video.play();
        } else {
          userPaused = true;
          video.pause();
        }
      });
    }

    if (reduced.matches) {
      video.autoplay = false;
      video.pause();
      setState('paused');
    } else {
      setState(video.paused ? 'paused' : 'playing');
    }
  }

  function enhanceAll() {
    document.querySelectorAll('superpowered-video').forEach(enhance);
  }

  enhanceAll();

  // Product media can be re-rendered on variant change / section reload.
  new MutationObserver(enhanceAll).observe(document.body, { childList: true, subtree: true });
})();
